const ventas = {
  cancelSubscription: 'academia/cancelar-suscripcion/{{uuid_suscripcion}}',
  readVenta: 'academia/venta/{{uuid_venta}}',
  readVentaDatosMigracion: 'venta/{{uuid_venta}}/datos-migracion',
  readVentaPagos: 'academia/venta/{{uuid_venta}}/pagos',
  readVentasAcademia: 'academia/ventas/{{uuid_academia}}',
  readVentasAcademiaExportar: 'academia/ventas/{{uuid_academia}}/exportar',
  readVentasMisCobros: 'academia/ventas/cobros/{{uuid_academia}}',
  readVentasMisCobrosExportar: 'academia/ventas/cobros/{{uuid_academia}}/exportar',
  readVentasMisPagos: 'academia/{{uuid_academia}}/pagos',
  readVentasListados: 'academia/ventas/{{uuid_academia}}',
  updateVentasAnularPago: 'academia/venta/{{uuid_venta}}/pago/{{uuid_pago}}/anular',
  updateVentasConfirmarPago: 'academia/venta/{{uuid_venta}}/pago/{{uuid_pago}}/confirmar',
  updateVentasReembolsarPago: 'academia/venta/{{uuid_venta}}/pago/{{uuid_pago}}/reembolsar' /* no está en postman */
}

export default ventas
